/**
 * Config for browser-direct AWS Transcribe streaming (faster voice).
 *
 * The browser exchanges its Cognito User Pool idToken for short-lived AWS creds
 * via the Cognito Identity Pool, then streams PCM straight to Amazon Transcribe.
 * These three VITE_ vars are baked into the build (public — they're just resource
 * identifiers, same class as the existing Cognito config in auth.ts).
 *
 * VITE_COGNITO_IDENTITY_POOL_ID is set AFTER the CDK deploy creates the pool
 * (CfnOutput IdentityPoolId) and is added to deploy.cjs REQUIRED so a missing
 * value hard-fails the build rather than silently shipping a no-op (per
 * project_env_production_full_keys). When it's absent, isVoiceStreamingConfigured()
 * returns false and the Voice UI falls back to the batch path.
 */

export const COGNITO_REGION = import.meta.env.VITE_COGNITO_REGION || 'us-east-1';
export const COGNITO_USER_POOL_ID = import.meta.env.VITE_COGNITO_USER_POOL_ID || '';
export const COGNITO_IDENTITY_POOL_ID = import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID || '';

/** The Cognito Identity Pool login key for the User Pool federation. */
export function cognitoLoginKey(): string {
  return `cognito-idp.${COGNITO_REGION}.amazonaws.com/${COGNITO_USER_POOL_ID}`;
}

/** True only when both the User Pool + Identity Pool ids are present. */
export function isVoiceStreamingConfigured(): boolean {
  return !!COGNITO_IDENTITY_POOL_ID && !!COGNITO_USER_POOL_ID;
}
